// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__QcIES","progressWrapper":"styles_progressWrapper__1nzOz","progress":"styles_progress__M1A3q","detail":"styles_detail__1C3F_"};